import { render, staticRenderFns } from "./ApproveMailWebpartTest.vue?vue&type=template&id=18bf62c8"
import script from "./ApproveMailWebpartTest.vue?vue&type=script&lang=js"
export * from "./ApproveMailWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports